import React, { useEffect, useState, useRef } from "react";
import classes from "./ChangePending.module.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import { Pen, Trash2, Printer, Eye } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Accordion, Tab, Tabs, Row, Col, Popover, Table } from 'react-bootstrap';
import Select from "react-select";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Swal from "sweetalert2";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaCalendarCheck } from "react-icons/fa";
import { FaCalendarXmark } from "react-icons/fa6";
import HeaderNav from "../../Budget/Budget Dashboard/HeaderNav/HeaderNav";

const ChangePending = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [description, setDescription] = useState('');
  const [selectedRadio, setSelectedRadio] = useState("");
  const [approveLoading, setApproveLoading] = useState(false);
  const [disapproveLoading, setDisapproveLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [totalEntries, setTotalEntries] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currLoading, setCurrLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [user, setUser] = useState('');
  const [loanBen, setLoanBen] = useState([]);
  const [roleLoading, setRoleLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState('');
  const [showPay, setShowPay] = useState(false);
  const handleClosePay = () => setShowPay(false);
  const handleShowPay = () => setShowPay(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);
  const [userProvinces, setUserProvinces] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const handleClose = () => {
    setShow(false);
    setDescription(''); // Clear the description on close
  };
  const [selectedItemId, setSelectedItemId] = useState(null);
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  const [paymentModes, setPaymentModes] = useState([]);
  const [selectOptions, setSelectOptions] = useState([]);
  const [currency, setCurrency] = useState([]);
  const payment = location.state?.payment;
  const [searchedResult, setSearchedResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [tableData1, setTableData1] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [show2, setShow2] = useState(false);
  const [tableData4, setTableData4] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableData5, setTableData5] = useState([]);
  const [selectedProvinces, setSelectedProvinces] = useState([]);
  const [selectedContinent, setSelectedContinent] = useState(null);

  // Add filter states
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [selectedContinentFilter, setSelectedContinentFilter] = useState(null);
  const [selectedRegionFilter, setSelectedRegionFilter] = useState(null);
  const [selectedProvinceFilter, setSelectedProvinceFilter] = useState(null);
  const [filtersLoading, setFiltersLoading] = useState(false);

  const handleShow = (id) => {
    setSelectedItemId(id);
    setShow(true);
  };

  const handleClose2 = () => {
    setTableData5([]);
    setSelectedProvinces([]);
    setShow2(false);
  };

  const handleShow1 = (user) => {
    setSelectedUser(user);
    setShow2(true);
  };

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    username: "",
    role: "",
    password: "",
    confirmPassword: "",
  });

  const [permissions, setPermissions] = useState({
    "User Management": { view: true, create: true, edit: false, delete: false, approve: false },
    Finance: { view: true, create: false, edit: false, delete: false, approve: true },
    Reports: { view: true, create: false, edit: false, delete: false, approve: false },
    Settings: { view: true, create: false, edit: true, delete: false, approve: false },
    Providers: { view: true, create: false, edit: true, delete: false, approve: false },
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (module, perm) => {
    setPermissions((prev) => ({
      ...prev,
      [module]: { ...prev[module], [perm]: !prev[module][perm] },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("User Data:", formData);
    console.log("Permissions:", permissions);
    handleClose();
  };

  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const selectedUserProvinces = selectedUser?.assigned_provinces?.map((item) => ({
    label: item.province_name,
    value: item.province_id,
  }));

  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion(null);
  };

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');

      if (value !== null && value.trim() !== '') {
        setBearer(value);
      } else {
        navigate('/login');
        return;
      }

      if (value1 !== null) {
        setUser(value1);
      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };

  const handleSelectedUserProvinceChange = (e, province) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setUserProvinces((prev) => {
        if (!prev.some((p) => p.value === province.value)) {
          return [...prev, { value: province.value, label: province.label }];
        }
        return prev;
      });
    } else {
      setUserProvinces((prev) => prev.filter((p) => p.value !== province.value));
    }
  };

  const createUser1 = async () => {
    setLoading(true);
    const mergedProvinces = [
      ...userProvinces.map((province) => province.value),
    ];

    try {
      const response = await axios.post(
        `${BASE_URL}/deassign-compliance-from-province`,
        {
          user_id: selectedUser?.user_id,
          province_id: mergedProvinces
        },
        { headers }
      );
      console.log(response);
      fetchData();
      handleClose2();

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      console.log(response.data);
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.log(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const createUser = async () => {
    setLoading(true);
    const mergedProvinces = [
      ...selectedProvinces.map((province) => province.value),
    ];

    try {
      const response = await axios.post(
        `${BASE_URL}/assign-compliance-to-province`,
        {
          user_id: selectedUser?.user_id,
          province_id: mergedProvinces
        },
        { headers }
      );
      console.log(response);
      fetchData();
      setSelectedProvinces([]);
      handleClose();

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      console.log(response.data);
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.log(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleProvinceChange = (e, province) => {
    const checked = e.target.checked;
    if (checked) {
      setSelectedProvinces((prev) => {
        if (!prev.some((p) => p.value === province.value)) {
          return [...prev, { value: province.value, label: province.label }];
        }
        return prev;
      });
    } else {
      setSelectedProvinces((prev) => prev.filter((p) => p.value !== province.value));
    }
  };

  const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);

  // Improved fetchData function with proper data extraction
  const fetchData = async () => {
    setRoleLoading(true);
    try {
      console.log("Fetching all working month data...");
      const response = await axios.get(
        `${BASE_URL}/provinces/get-initiated-working-month`,
        { headers }
      );

      console.log("Full API Response:", response);
      console.log("Response Data:", response.data);

      let results = [];
      let totalEntries = 0;

      // Handle the specific API response structure: {status: true, data: {data: [], total: X}}
      if (response.data && response.data.data) {
        // Check for nested data structure
        if (response.data.data.data && Array.isArray(response.data.data.data)) {
          results = response.data.data.data;
          totalEntries = response.data.data.total || 0;
        }
        // Check if data is directly an array
        else if (Array.isArray(response.data.data)) {
          results = response.data.data;
          totalEntries = response.data.data.length;
        }
        // If data exists but no array found, set empty results
        else {
          results = [];
          totalEntries = 0;
        }
      } else {
        results = [];
        totalEntries = 0;
      }

      console.log("Extracted Results:", results);
      console.log("Total Entries:", totalEntries);

      setTableData(results);
      setTotalEntries(totalEntries);
      setTotalPages(Math.ceil(totalEntries / entriesPerPage) || 1);

    } catch (error) {
      console.error("Fetch Data Error:", error);
      setTableData([]);
      setTotalEntries(0);
      setTotalPages(1);

      Swal.fire({
        icon: 'error',
        title: 'Failed to load data',
        text: 'Please check your connection and try again.',
      });
    } finally {
      setRoleLoading(false);
    }
  };

  // Filter data using the distinct API based on selected filters
  const fetchFilteredData = async () => {
    setRoleLoading(true);
    try {
      // Build query parameters based on selected filters
      const queryParams = new URLSearchParams();

      if (selectedContinentFilter) {
        queryParams.append('continent_id', selectedContinentFilter.value);
      }
      if (selectedRegionFilter) {
        queryParams.append('region_id', selectedRegionFilter.value);
      }
      if (selectedProvinceFilter) {
        queryParams.append('province_id', selectedProvinceFilter.value);
      }

      const url = `${BASE_URL}/provinces/get-initiated-working-month-distinct${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

      console.log("Fetching filtered data from:", url);

      const response = await axios.get(url, { headers });
      console.log("Filtered API Response:", response.data);

      let results = [];
      let totalEntries = 0;

      // Handle the filtered API response structure
      if (response.data && response.data.data) {
        // Check for nested data structure in filtered response
        if (response.data.data.data && Array.isArray(response.data.data.data)) {
          results = response.data.data.data;
          totalEntries = response.data.data.total || 0;
        }
        // Check if data is directly an array
        else if (Array.isArray(response.data.data)) {
          results = response.data.data;
          totalEntries = response.data.data.length;
        }
        // If no data found
        else {
          results = [];
          totalEntries = 0;
        }
      } else {
        results = [];
        totalEntries = 0;
      }

      console.log("Filtered Results:", results);
      console.log("Filtered Total Entries:", totalEntries);

      setTableData(results);
      setTotalEntries(totalEntries);
      setTotalPages(Math.ceil(totalEntries / entriesPerPage) || 1);

    } catch (error) {
      console.error("Fetch Filtered Data Error:", error);
      setTableData([]);
      setTotalEntries(0);
      setTotalPages(1);

      Swal.fire({
        icon: 'error',
        title: 'Failed to load filtered data',
        text: 'Please check your filters and try again.',
      });
    } finally {
      setRoleLoading(false);
    }
  };

  // Fetch continents
  const fetchContinents = async () => {
    try {
      if (!bearer) return;
      setFiltersLoading(true);

      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      console.log("Continents API Response:", response.data);

      let continentsData = [];
      if (response.data.status && response.data.data) {
        continentsData = response.data.data;
      } else if (Array.isArray(response.data)) {
        continentsData = response.data;
      } else if (response.data.data) {
        continentsData = response.data.data || [];
      }

      setContinents(continentsData);
      console.log("Continents Data:", continentsData);
    } catch (error) {
      console.error("Error fetching continents:", error);
      setContinents([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Fetch regions based on selected continent
  const fetchRegionsForFilter = async (continentId) => {
    if (!continentId) {
      setRegions([]);
      return;
    }

    try {
      setFiltersLoading(true);
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });

      let regionsData = [];
      if (response.data.status && response.data.data) {
        if (Array.isArray(response.data.data)) {
          regionsData = response.data.data;
        } else if (response.data.data.regions && Array.isArray(response.data.data.regions)) {
          regionsData = response.data.data.regions;
        }
      } else if (Array.isArray(response.data)) {
        regionsData = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        regionsData = response.data.data;
      }

      setRegions(regionsData || []);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Fetch provinces based on selected region
  const fetchProvincesForFilter = async (regionId) => {
    if (!regionId) {
      setProvinces([]);
      return;
    }

    try {
      setFiltersLoading(true);
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`, { headers });

      let provincesData = [];
      if (response.data.status) {
        if (response.data.data && response.data.data.provinces) {
          provincesData = response.data.data.provinces;
        } else if (Array.isArray(response.data.data)) {
          provincesData = response.data.data;
        } else {
          provincesData = response.data.data || [];
        }
      } else if (Array.isArray(response.data)) {
        provincesData = response.data;
      } else if (response.data.data) {
        provincesData = response.data.data || [];
      }

      setProvinces(provincesData || []);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setProvinces([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Handle continent filter change
  const handleContinentFilterChange = (selectedOption) => {
    setSelectedContinentFilter(selectedOption);
    setSelectedRegionFilter(null);
    setSelectedProvinceFilter(null);
    setCurrentPage(1);
  };

  // Handle region filter change
  const handleRegionFilterChange = (selectedOption) => {
    setSelectedRegionFilter(selectedOption);
    setSelectedProvinceFilter(null);
    setCurrentPage(1);
  };

  // Handle province filter change
  const handleProvinceFilterChange = (selectedOption) => {
    setSelectedProvinceFilter(selectedOption);
    setCurrentPage(1);
  };

  // Fetch regions when continent filter changes
  useEffect(() => {
    if (selectedContinentFilter) {
      fetchRegionsForFilter(selectedContinentFilter.value);
    } else {
      setRegions([]);
      setSelectedRegionFilter(null);
      setSelectedProvinceFilter(null);
    }
  }, [selectedContinentFilter]);

  // Fetch provinces when region filter changes
  useEffect(() => {
    if (selectedRegionFilter) {
      fetchProvincesForFilter(selectedRegionFilter.value);
    } else {
      setProvinces([]);
      setSelectedProvinceFilter(null);
    }
  }, [selectedRegionFilter]);

  // Determine which data to fetch based on filters
  useEffect(() => {
    if (bearer) {
      console.log("Filters changed - Continent:", selectedContinentFilter, "Region:", selectedRegionFilter, "Province:", selectedProvinceFilter);

      // If any filter is selected, use the distinct API for filtering
      if (selectedContinentFilter || selectedRegionFilter || selectedProvinceFilter) {
        console.log("Using filtered data API");
        fetchFilteredData();
      } else {
        // If no filters are selected, show all data
        console.log("Using all data API");
        fetchData();
      }
    }
  }, [bearer, currentPage, selectedContinentFilter, selectedRegionFilter, selectedProvinceFilter]);

  // Also fetch continents on initial load
  useEffect(() => {
    if (bearer) {
      fetchContinents();
      // Fetch initial data
      fetchData();
    }
  }, [bearer]);

  const handleTrashClick = async (uuid) => {
    const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this payment.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    });

    if (!confirmed.isConfirmed) {
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}/payments/delete_perm?uuid=${uuid}`, { headers });
      Swal.fire({
        imageUrl: verified,
        title: 'Success!',
        text: response.data.message,
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        }
      });
      // Refresh data after delete
      if (selectedContinentFilter || selectedRegionFilter || selectedProvinceFilter) {
        fetchFilteredData();
      } else {
        fetchData();
      }
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false,
          preConfirm: () => {
            Swal.close();
          },
        });
      }
    }
  };

  const handlePrint = (uuid) => {
    const selectedInvoice = tableData.find((item) => item.uuid === uuid);
    if (selectedInvoice) {
      navigate("/print_payments", {
        state: { invoice: selectedInvoice },
      });
    }
  };

  const fetchCurrency1 = async () => {
    setCurrLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
      const results = response.data?.data;
      const options = results.map((item) => ({
        label: item.code,
        value: item.id,
        symbol: item.symbol,
        country: item.country
      }));
      setCurrency(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCurrency([]);
    } finally {
      setCurrLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchCurrency1();
    }
  }, [bearer]);

  const fetchLoanBen = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/loan-customers-select`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      console.log(response, "loan Benf");
      setLoanBen(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setLoanBen([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchLoanBen();
    }
  }, [bearer]);

  const addLine = () => {
    setRows((prev) => [
      ...prev,
      { accountId: "", accountDisplay: "", amount: "", showDropdown: false },
    ]);
  };

  const fetchMode = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/income/get-payment-method`, { headers });
      const results = response.data?.data;
      setPaymentModes(results);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setPaymentModes([]);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchMode();
    }
  }, [bearer]);

  const totalDebit = parseFloat(totalAmount || 0);
  const totalCredit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );
  const isBalanced = totalDebit === totalCredit;

  const filteredData = tableData.filter(item =>
    item.province_name && item.province_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const dataToRender = searchTerm.trim()
    ? filteredData
    : tableData;

  const isNoResults = !roleLoading && dataToRender.length === 0;

  const handleApprove = async (id) => {
    const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to approve this`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Approve it!',
      cancelButtonText: 'No, Cancel',
    });

    if (!confirmed.isConfirmed) {
      return;
    }

    Swal.fire({
      title: 'Approving...',
      text: 'Please wait while your request is being processed.',
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    try {
      const response = await axios.post(
        `${BASE_URL}/provinces/approve-working-month`,
        {
          id: id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`,
          },
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      // Refresh data after approve
      if (selectedContinentFilter || selectedRegionFilter || selectedProvinceFilter) {
        fetchFilteredData();
      } else {
        fetchData();
      }
      console.log(response.data);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
      console.log(error);
    }
  };

  const handleDisApprove = async () => {
    const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to disapprove this`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'No, Cancel',
    });

    if (!confirmed.isConfirmed) {
      return;
    }

    Swal.fire({
      title: 'Disapproving...',
      text: 'Please wait while your request is being processed.',
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    setDisapproveLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/provinces/disapprove-working-month`,
        {
          id: selectedItemId,
          description: description
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`,
          },
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      handleClose();
      // Refresh data after disapprove
      if (selectedContinentFilter || selectedRegionFilter || selectedProvinceFilter) {
        fetchFilteredData();
      } else {
        fetchData();
      }
      console.log(response.data);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setDisapproveLoading(false);
    }
  };

  // Prepare options for react-select
  const continentOptions = Array.isArray(continents)
    ? continents.map(continent => ({
      value: continent.id,
      label: continent.description || 'Unnamed Continent'
    }))
    : [];

  const regionOptions = Array.isArray(regions)
    ? regions.map(region => ({
      value: region.id,
      label: region.description || 'Unnamed Region'
    }))
    : [];

  const provinceOptions = Array.isArray(provinces)
    ? provinces.map(province => ({
      value: province.id,
      label: province.description || 'Unnamed Province'
    }))
    : [];

  return (
    <div>
      <HeaderNav />

      <div className={classes.Container}>
        <Modal show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Reason for Disapproving</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Description</Form.Label>
                <textarea
                  className="form-control"
                  rows="3"
                  cols="50"
                  placeholder="Enter reason here..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="success" onClick={handleDisApprove}>
              {disapproveLoading ? (
                <>
                  <Spinner size='sm' />
                  <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                </>
              ) : (
                "Disapprove"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={show2} onHide={handleClose2} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Unassign Provinces </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form style={{ marginBottom: 20 }}>
              <div style={{ marginTop: 10 }} />
              <Accordion>
                <Accordion.Item>
                  <Accordion.Header>Assigned Provinces</Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      {selectedUserProvinces && selectedUserProvinces.length > 0 ? (
                        selectedUserProvinces.map((province) => {
                          const isChecked = userProvinces.some((p) => p.value === province.value);
                          return (
                            <div key={province.value} className="col-md-4 mb-3">
                              <label className="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  value={province.value}
                                  className="me-2"
                                  checked={isChecked}
                                  onChange={(e) => handleSelectedUserProvinceChange(e, province)}
                                />
                                <span>{province.label}</span>
                              </label>
                            </div>
                          );
                        })
                      ) : (
                        <p>No provinces have been assigned to this user. Please select a continent and region to start with.</p>
                      )}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Form>
            <Modal.Footer>
              <Button variant="light" onClick={handleClose2}>
                Go back
              </Button>
              <Button variant="success" onClick={createUser1} className={classes.btnss}>
                {loading ? (
                  <>
                    <Spinner size="sm" />
                    <span style={{ marginLeft: "5px" }}>
                      Saving Changes, Please wait...
                    </span>
                  </>
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>

        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Pending Working Month Request</h2>
        </header>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            {/* Continent Dropdown */}
            <div className={classes.selectWrapper} style={{ width: '200px' }}>
              {filtersLoading && continents.length === 0 ? (
                <Skeleton height={40} borderRadius={8} />
              ) : (
                <Select
                  value={selectedContinentFilter}
                  onChange={handleContinentFilterChange}
                  options={continentOptions}
                  placeholder="Select Continent"
                  isClearable
                  className={classes.filterSelect}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '40px',
                      fontSize: '14px'
                    })
                  }}
                />
              )}
            </div>

            {/* Region Dropdown */}
            <div className={classes.selectWrapper} style={{ width: '180px' }}>
              {filtersLoading && selectedContinentFilter && regions.length === 0 ? (
                <Skeleton height={40} borderRadius={8} />
              ) : (
                <Select
                  value={selectedRegionFilter}
                  onChange={handleRegionFilterChange}
                  options={regionOptions}
                  placeholder="Select Region"
                  isClearable
                  isDisabled={!selectedContinentFilter}
                  className={classes.filterSelect}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '40px',
                      fontSize: '14px'
                    })
                  }}
                />
              )}
            </div>

            {/* Province Dropdown */}
            <div className={classes.selectWrapper} style={{ width: '180px' }}>
              {filtersLoading && selectedRegionFilter && provinces.length === 0 ? (
                <Skeleton height={40} borderRadius={8} />
              ) : (
                <Select
                  value={selectedProvinceFilter}
                  onChange={handleProvinceFilterChange}
                  options={provinceOptions}
                  placeholder="Select Province"
                  isClearable
                  isDisabled={!selectedRegionFilter}
                  className={classes.filterSelect}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '40px',
                      fontSize: '14px'
                    })
                  }}
                />
              )}
            </div>
          </div>

          <div className={classes.inputWrapper} style={{ marginLeft: 'auto' }}>
            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
            <input
              type="text"
              className={classes.searchBar}
              placeholder="Search province"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead style={{ whiteSpace: "nowrap" }}>
              <tr style={{ fontSize: "12px" }}>
                <th style={{ width: "5%" }}>S/N</th>
                <th style={{ width: "30%" }}>Province Name</th>
                <th style={{ width: "15%" }}>Last Date</th>
                <th style={{ width: "15%" }}>Current Date</th>
                <th style={{ width: "15%" }}>Date Approved</th>
                <th style={{ width: "15%" }}>Approved By</th>
                <th style={{ width: "30%" }}>Status</th>
                <th style={{ width: "7%" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {roleLoading
                ? Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(8).fill().map((_, i) => (
                      <td key={i}>
                        <Skeleton height={20} style={{ marginBottom: 10 }} />
                      </td>
                    ))}
                  </tr>
                ))
                : isNoResults ? (
                  <tr>
                    <td colSpan={8} style={{ textAlign: "center", padding: "20px" }}>
                      {searchTerm ? "No results found for your search." : "No working month requests found."}
                    </td>
                  </tr>
                ) : (
                  dataToRender.map((item, index) => (
                    <tr key={item.id || index} style={{ fontSize: "12px" }}>
                      <td>{index + 1}</td>
                      <td style={{ textWrap: 'nowrap' }}>{item.province_name || 'N/A'}</td>
                      <td style={{ width: 50 }}>{item.last_date || 'N/A'}</td>
                      <td>{item.current_date || 'N/A'}</td>
                      <td>{item.approved_date || 'N/A'}</td>
                      <td>{item.approved_by_name || item.disapproved_by_name || 'N/A'}</td>
                      <td style={{ display: "flex", width: 100, justifyContent: "center", alignItems: "center" }}>
                        {item.status === "1" ? (
                          <div
                            style={{
                              height: 15,
                              width: 80,
                              border: "1px solid #50b848",
                              borderRadius: 3,
                              color: "#50b848",
                              fontSize: 10,
                              textAlign: "center",
                              fontWeight: 700
                            }}
                          >
                            APPROVED
                          </div>
                        ) : item.status === "2" ? (
                          <div
                            style={{
                              height: 15,
                              width: 80,
                              border: "1px solid #dc3545",
                              borderRadius: 3,
                              color: "#dc3545",
                              fontSize: 10,
                              textAlign: "center",
                              fontWeight: 700
                            }}
                          >
                            DISAPPROVED
                          </div>
                        ) : item.status === "0" && item.progress_direction === "1" ? (
                          <div
                            style={{
                              height: 15,
                              width: 80,
                              border: "1px solid #ffc107",
                              borderRadius: 3,
                              color: "#ffc107",
                              fontSize: 10,
                              textAlign: "center",
                              fontWeight: 700
                            }}
                          >
                            INITIATED
                          </div>
                        ) : (
                          <div
                            style={{
                              height: 15,
                              width: 80,
                              border: "1px solid #078fffffff",
                              borderRadius: 3,
                              color: "#078fffffff",
                              fontSize: 10,
                              textAlign: "center",
                              fontWeight: 700
                            }}
                          >
                            REVERSED
                          </div>
                        )}
                      </td>
                      <td style={{ padding: 5 }}>
                        {item.status !== '1' && item.status !== '2' && (
                          <>
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="button-tooltip">Click to approve this changed working month</Tooltip>}
                            >
                              <FaCalendarCheck onClick={() => handleApprove(item.id)} style={{ height: 22, color: "#2d995f", cursor: 'pointer', }} />
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="button-tooltip">Click to disapprove this working month</Tooltip>}
                            >
                              <FaCalendarXmark style={{ height: 22, color: "#dc3545", cursor: 'pointer', marginLeft: 10 }} onClick={() => handleShow(item.id)} />
                            </OverlayTrigger>
                          </>
                        )}
                      </td>
                    </tr>
                  ))
                )}
            </tbody>
          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >Previous</button>
              {[...Array(totalPages)].map((_, page) => {
                if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                  return (
                    <button className={classes.active} key={page + 1}
                      style={{
                        color: page + 1 === currentPage ? '#ffffff' : '#000',
                        backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                        cursor: "pointer",
                        marginLeft: 5
                      }}
                      onClick={() => setCurrentPage(page + 1)}
                    > {page + 1}
                    </button>
                  );
                }
                return null;
              })}
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >Next
              </button>
              <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePending;